<template>
<div class="img-ext">
  <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left pl-0">
              <h2 class="page-title">{{$t('registration.tabs.tabImageExtractor')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">85%</h2>
            </div>
          </div>
        </div>
    <div class="row title justify-content-center">
        <button @click="prevDoc" class="btn btn-default"><i class="mdi mdi-chevron-left"></i></button>
        <span>{{title}}</span>
        <button @click="nextDoc" class="btn btn-default"><i class="mdi mdi-chevron-right"></i></button>
    </div>
    <div class="row">
        <div class="col-8 pl-0">
            <div class="imgcss" id="container" :style="{ backgroundImage: 'url(' + imagePath + ')',  backgroundSize: '600px 800px', backgroundRepeat: 'no-repeat' }">
            </div>
        </div>
        <form class="col-4 bg-grey-form" action="POST" v-on:submit.prevent="save('form-1')" data-vv-scope="form-1">
                    <div v-if="questionList.length < 1">
                      <!-- {{$t('candidateProfile.imageExtracter.lblHallTicketNote')}} -->
                    </div>
                    <div v-for="(que,index) in questionList" v-bind:key="index">
                        <div class="wrap-cb mt-0">
                            <div class="row">
                                <div class="col align-self-center">
                                    <label class="c-wrap"> {{que.title}} <sup>
                                      <i class="mdi mdi-star text-danger"></i>
                                  </sup>
                                    <!-- <input type="checkbox"  :true-value=true :false-value=false @click="changeCheckBox(que)" v-model="que.selected">
                                    <span class="checkmark"></span> -->
                                    </label>
                                </div>
                                <!-- <div class="col-auto align-self-center text-left">
                                    <button type="button" @click="crop(que)" :disabled="!que.selected" :class="{'btn-rg' : que.crop}" class="btn btn-success-alt">{{$t('candidateProfile.imageExtracter.lblCrop')}}</button>
                                </div> -->
                                </div>
                                <div class="row no-gutters">
                                
                                <div class="col align-self-center">
                                    <div class="form-group custom-input col-12">
                                        <input type="text" class="form-control-alt col-12 " :id="que.title" :name="que.title" v-model="que.value" v-validate="{'required' : true,'regex': que.regex}" :class="{'form-error': errors.has('form-1.'+que.title),'input': true, 'is-danger': errors.has('form-1.'+que.title) }" :placeholder="que.placeholder">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </form>
    </div>
   <div class=" row text-center p-3">
        <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
        <button type="button" class="btn btn btn-orange ml-auto" @click="nextTabFunc"> {{$t('button.next')}}</button>
    </div>
</div>
</template>

<script>
import Konva from 'konva'
import axios from 'axios'
export default {
  name: 'ImageExtracter',
  data () {
    return {
      title: '',
      index: 0,
      darthVaderGroup: {},
      imagePath: '',
      questionList: [],
      documentList: [],
      imgposition: {x: 0, y: 0}
    }
  },
  methods: {
    nextTabFunc () {
      this.save()
    },
    prevTabFunc () {
      this.$router.push('documentsupload')
    },
    changeCheckBox (item) {
      for (let index = 0; index < this.questionList.length; index++) {
        if (item.field === this.questionList[index].field) {
          let temp = this.questionList
          this.questionList = []
          temp[index].field = item.field
          this.questionList = temp
        }
      }
    },
    nextDoc () {
      var self = this
      this.$validator.validate().then((result) => {
        if (!result) {
          for (var i in self.questionList) {
            if (self.questionList[i].value.trim() === '') {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + self.questionList[i].title, {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              })
            }
          }
        } else {
          if (this.getDoc(this.index + 1) === true) {
            this.documentList[this.index].completed = true
            this.index++
          }
        }
      })
    },
    prevDoc () {
      var self = this
      this.$validator.validate().then((result) => {
        if (!result) {
          for (var i in self.questionList) {
            if (self.questionList[i].value.trim() === '') {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + self.questionList[i].title, {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              })
            }
          }
        } else {
          if (this.getDoc(this.index - 1) === true) {
            this.documentList[this.index].completed = true
            this.index--
          }
        }
      })
    },
    getDoc (i) {
      if (i < this.documentList.length && i > -1) {
        this.title = this.documentList[i].title
        this.imagePath = this.documentList[i].marksheetUrl
        this.questionList = this.documentList[i].questions
        return true
      }
      return false
    },
    crop (que) {
      que.crop = true
      this.capturePoints(this.imgposition.x, this.imgposition.y, this.darthVaderGroup.children[0].attrs.width, this.darthVaderGroup.children[0].attrs.height, 'id', que)
    },
    getDocumentDetails () {
      var profileUser = this.$store.state.candidateProfile.profileUser
      var self = this
      axios.get('r/ocr/documents/' + profileUser)
         .then(function (response) {
           if (response.status === 200) {
             self.documentList = response.data
             if (self.documentList.length > 0) {
               self.getDoc(0)
             }
           }
         }).catch(function (e) {
           console.error(e)
           self.$toasted.error(self.$('candidateProfile.imageExtracter.toastrCertificationDetailsFeatchError'), {
             theme: 'bubble',
             duration: self.TOASTR_TIME
           })
         })
    },
    save () {
      if (this.index < this.documentList.length - 1) {
        this.nextDoc()
        return false
      }
      var profileUser = this.$store.state.candidateProfile.profileUser
      var self = this
      return this.$validator.validate().then((result) => {
        if (result) {
          this.documentList[this.index].completed = true
          for (var i in this.documentList) {
            if (this.documentList.length > 1 && (this.documentList[i].completed === undefined || !this.documentList[i].completed)) {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + this.documentList[i].title + ' details', {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              })
              return false
            }
          }
          return axios.post('r/candidateProfile/saveEducationFieldDetails/' + profileUser, this.documentList)
            .then(function (response) {
              if (response.status === 200) {
                self.$toasted.success(self.$t('toastr.toastrEducationalDetailsSaved'), {
                  theme: 'bubble',
                  duration: self.TOASTR_TIME
                })
                self.$router.push({name: 'profileSummary'})
                return true
              }
              return false
            })
            .catch(function (e) {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrCertificationDetailsFeatchError'), {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              })
              return false
            })
        } else {
          for (var j in self.questionList) {
            if (self.questionList[j].value.trim() === '') {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + self.questionList[j].title, {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              })
            }
          }
          return false
        }
      })
    },
    addAnchor (group, x, y, name) {
      var self = this
      // var stage = group.getStage();
      var layer = group.getLayer()
      var anchor = new Konva.Circle({
        x: x,
        y: y,
        stroke: '#666',
        fill: '#ddd',
        strokeWidth: 2,
        radius: 8,
        name: name,
        draggable: true,
        dragOnTop: false
      })

      anchor.on('dragmove', function () {
        self.update(this)
        layer.draw()
      })
      anchor.on('mousedown touchstart', function () {
        group.setDraggable(false)
        this.moveToTop()
      })
      anchor.on('dragend', function () {
        group.setDraggable(true)
        layer.draw()
      })
      // add hover styling
      anchor.on('mouseover', function () {
        var layer = this.getLayer()
        document.body.style.cursor = 'pointer'
        this.setStrokeWidth(2)
        layer.draw()
      })
      anchor.on('mouseout', function () {
        var layer = this.getLayer()
        document.body.style.cursor = 'default'
        this.setStrokeWidth(2)
        layer.draw()
      })

      group.add(anchor)
      self.darthVaderGroup = group
    },
    capturePoints (x, y, w, h, id, que) {
      let obj = {}
      obj.x = x
      obj.y = y
      obj.w = w
      obj.h = h
      obj.imagePath = this.imagePath
      var self = this
      if (this.imagePath === undefined || this.imagePath === null || this.imagePath === '') {
        self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrImageNotAvailable'), {
          theme: 'bubble',
          duration: self.TOASTR_TIME
        })
        return false
      }
      axios.post('r/ocr/parse', obj)
         .then(function (response) {
           if (response.status === 200) {
             que.value = response.data.result
           }
         }).catch(function () {
           self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrCertificationListFeatchError'), {
             theme: 'bubble',
             duration: self.TOASTR_TIME
           })
         })
    },
    updateGroup (group) {
      this.darthVaderGroup = group
      var topLeft = group.get('.topLeft')[0]
      var anchorX = group.getX()
      var anchorY = group.getY()
      this.imgposition.y = anchorY + topLeft.getY()
      this.imgposition.x = anchorX + topLeft.getX()
    },
    update (activeAnchor) {
      var group = activeAnchor.getParent()
      // var layer = group.getLayer()
      var topLeft = group.get('.topLeft')[0]
      var topRight = group.get('.topRight')[0]
      var bottomRight = group.get('.bottomRight')[0]
      var bottomLeft = group.get('.bottomLeft')[0]
      var image = group.get('Image')[0]

      var anchorX = activeAnchor.getX()
      var anchorY = activeAnchor.getY()

      // update anchor positions
      switch (activeAnchor.getName()) {
        case 'topLeft':
          topRight.setY(anchorY)
          bottomLeft.setX(anchorX)
          break
        case 'topRight':
          topLeft.setY(anchorY)
          bottomRight.setX(anchorX)
          break
        case 'bottomRight':
          bottomLeft.setY(anchorY)
          topRight.setX(anchorX)
          break
        case 'bottomLeft':
          bottomRight.setY(anchorY)
          topLeft.setX(anchorX)
          break
      }
      image.position(topLeft.position())
      var width = topRight.getX() - topLeft.getX()
      var height = bottomLeft.getY() - topLeft.getY()
      if (width && height) {
        image.width(width)
        image.height(height)
      }
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getDocumentDetails()
    }
  },
  mounted: function () {
    var self = this
    var stage = new Konva.Stage({
      container: 'container',
      width: 600,
      height: 800,
      transparent: true
    })

    var layer = new Konva.Layer()
    stage.add(layer)

    // darth vader
    var darthVaderImg = new Konva.Image({
      width: 200,
      height: 137
    })

    var darthVaderGroup = new Konva.Group({
      x: 0,
      y: 0,
      draggable: true
    })
    self.darthVaderGroup = darthVaderGroup

    layer.add(darthVaderGroup)
    darthVaderGroup.add(darthVaderImg)
    self.addAnchor(darthVaderGroup, 0, 0, 'topLeft')
    self.addAnchor(darthVaderGroup, 200, 0, 'topRight')
    self.addAnchor(darthVaderGroup, 200, 138, 'bottomRight')
    self.addAnchor(darthVaderGroup, 0, 138, 'bottomLeft')
    var imageObj1 = new Image()
    imageObj1.onload = function () {
      darthVaderImg.image(imageObj1)
      layer.draw()
    }
//    imageObj1.src = 'static/assets/images/login/rectangle.png'

    darthVaderGroup.on('dragmove', function () {
      self.updateGroup(this)
      layer.draw()
    })
    darthVaderGroup.on('dragend', function () {
      layer.draw()
    })
    // add hover styling
    darthVaderGroup.on('mouseover', function () {
      // var layer = this.getLayer()
      document.body.style.cursor = 'pointer'
      // this.setStrokeWidth(2)
      layer.draw()
    })
    darthVaderGroup.on('mouseout', function () {
      // var layer = this.getLayer()
      document.body.style.cursor = 'default'
      // this.setStrokeWidth(2)
      layer.draw()
    })
  }
}
</script>

<style lang="scss">
.img-ext{
    // .cbox{margin-bottom:30px;}
    .title{
        span{display: inline-block; margin-top:10px; font-weight:500;}
        .btn{box-shadow: none; color:#ccc; font-size:30px; padding-top:0px; padding-bottom:0px; &:hover{color:#555;}}
    }
    .imgcss{
       padding:'0px';
    }
    .wrap-cb{
        margin-bottom:20px;
        margin-top:28px;
    }
    .btn{padding:8px 30px;}
//   .btn-gr {
//      background: green
//   }
}
.bg-grey-form{
     background: #f9f9f9;
    /* box-shadow: 3px -1px 1px rgba(0,0,0,0.2) inset; */
    border: 2px dashed #ddd;
}
</style>







// WEBPACK FOOTER //
// src/components/registration/imageExtracter.vue